import { CardContent } from '@repo/ui/components/ui/card'
import { surfaceSpacing } from '@repo/ui/lib/design-tokens'
import { createFileRoute } from '@tanstack/react-router'
import {
  OperatorSetupWizard,
  SetupShellLoadingState,
} from '@/components/operator-onboarding/editors'
import { PremiumPanel } from '@/components/ui/premium-panel'
import { useOperatorConfiguration } from '@/lib/operator-config/use-operator-configuration'
import type { RouteStaticData } from '@/lib/router/breadcrumbs'

export const Route = createFileRoute('/_app/setup')({
  component: SetupPage,
  staticData: {
    breadcrumbs: [{ label: 'Setup' }],
  } satisfies RouteStaticData,
})

function SetupPage() {
  const { configuration, readiness, isLoading, error, refreshAll } = useOperatorConfiguration()

  return (
    <div className="min-h-[100dvh] bg-background">
      {isLoading ? (
        <SetupShellLoadingState />
      ) : error ? (
        <PremiumPanel tone="destructive" className="m-6">
          <CardContent className={`${surfaceSpacing.insetY.roomy} text-sm text-destructive`}>
            {error.message}
          </CardContent>
        </PremiumPanel>
      ) : (
        <OperatorSetupWizard
          configuration={configuration}
          readiness={readiness}
          onSaved={refreshAll}
        />
      )}
    </div>
  )
}
